import { ActionMap, StoreActions } from '../reducer.types';
import { AppState, AppStorePayload, AppStoreActionTypes } from './AppStore.types';
import Strings from '../../common/Strings';

export type AppStoreActions = ActionMap<AppStorePayload>[keyof ActionMap<AppStorePayload>];

export const AppStoreReducer = (state: AppState, action: StoreActions) => {
  switch (action.type) {
    case AppStoreActionTypes.SetLoading:
      return { ...state, isLoading: true, loadingMessage: action.payload, isPublishSuccess: false, isPublishError: false, publishErrorMessage: '' };
    case AppStoreActionTypes.SetRecentProject:
      return { ...state, recentProject: action.payload };
    case AppStoreActionTypes.SetIsHomePage:
      return { ...state, isHomePage: action.payload };
    case AppStoreActionTypes.SetIssueTypeAvailability:
      return { ...state, issueTypeAvailability: action.payload };
    case AppStoreActionTypes.SetPublishSuccess:
      return { ...state, isPublishSuccess: action.payload };
    case AppStoreActionTypes.SetPublishError:
      return { 
        ...state, 
        isPublishError: action.payload !== false, 
        publishErrorMessage: action.payload !== false ? action.payload : '' 
      };
    case AppStoreActionTypes.RemoveLoading: {
      return { ...state, isLoading: false, loadingMessage: Strings.GENERATE_LOADER_MESSAGE, isPublishSuccess: false, isPublishError: false, publishErrorMessage: '' };
    }
    default:
      return state;
  }
};
